import { SiteHeaderType } from '../models/site-header-type.enum';

export class LayoutStateModel {
    public theme: string;
    public sidenav: LayoutSidenav;
    public siteHeader: SiteHeaderType;
}

export class LayoutSidenav {
    enabled: boolean;
    open: boolean;
}
